import React, { useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Menu,
  X,
  Moon,
  Sun,
  ArrowRight,
  MapPin,
  YoutubeIcon,
  PlayCircle,
} from "lucide-react";
import { Link } from "react-router-dom";
import FloatingButtons from "components/FloatingActionButtons/FloatingButtons";
// import "./App.css";

const App = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);

  // For typing effect
  const [typedText, setTypedText] = useState("");
  const fullText = "UNVEIL THE BEST FARMLANDS IN HUBBALLI-DHARWAD";

  useEffect(() => {
    let index = 0;
    const typingInterval = setInterval(() => {
      if (index <= fullText.length) {
        setTypedText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(typingInterval);
      }
    }, 100);

    return () => clearInterval(typingInterval);
  }, []);

  // For carousel
  const slides = ["https://akwed1.s3.us-east-1.amazonaws.com/main_vid.mp4"];

  const handleVideoCanPlay = () => {
    setVideoLoading(false);
    setVideoError(false);
  };

  const handleVideoError = () => {
    setVideoLoading(false);
    setVideoError(true);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle("dark");
  };

  // Jacuzzi, Fishpond, Bar Counter, Dance Floor with Disco Lights, Rain Dance, Kids Play Area, Indoor Games, Outdoor Games, Gym, Library, TV Music System and Fridge.
  const amenities = [
    { name: "Badminton Court", icon: "🏸" },
    { name: "Bonfire", icon: "🔥" },
    { name: "Fish Pond", icon: "🐟" },
    { name: "Gym", icon: "💪" },
    { name: "Indoor Games", icon: "🎮" },
    { name: "Jacuzzi", icon: "🌊" },
    { name: "Kids Playground", icon: "🧒" },
    { name: "Library", icon: "📚" },
    { name: "Rain Dance", icon: "💃" },
    { name: "Dance Floor", icon: "🕺" },
    { name: "Bar Counter", icon: "🍷" },
    { name: "Outdoor Games", icon: "⚽" },
    { name: "TV Music System", icon: "🎵" },
    { name: "Fridge", icon: "❄️" },
  ];

  return (
    <div
      className={`min-h-screen ${
        darkMode ? "dark bg-gray-900 text-white" : "bg-white text-gray-900"
      }`}
    >
      {/* Main Content */}

      <FloatingButtons />
      <main>
        {/* Hero Carousel */}
        <section className="relative h-[calc(100vh-76px)] min-h-[500px] overflow-hidden">
          <div className="absolute inset-0">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  index === currentSlide ? "opacity-100" : "opacity-0"
                }`}
              >
                {/* Fallback Image - shows while video is loading */}
                {(videoLoading || videoError) && (
                  <img
                    src="/svgs/wl_1.jpg"
                    alt="Sri Farmlands - Best Farmlands in Hubballi-Dharwad"
                    className="absolute inset-0 w-full h-full object-cover z-10"
                  />
                )}

                <video
                  className="absolute top-0 left-0 w-full h-full object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  onCanPlay={handleVideoCanPlay}
                  onError={handleVideoError}
                  onWaiting={() => setVideoLoading(true)}
                  onPlaying={() => setVideoLoading(false)}
                >
                  <source src={`${slide}`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                {/* <iframe
                  src={require(`../${slide}`)}
                  alt="Plot in Hubballi for sale"
                  className="w-full h-full object-cover"
                /> */}
              </div>
            ))}
          </div>

          {/* Carousel Controls */}
          {/* <button
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 dark:bg-gray-800/30 dark:hover:bg-gray-800/50 p-2 rounded-full text-gray-900 dark:text-white"
            onClick={prevSlide}
          >
            <ChevronLeft size={24} />
          </button> */}
          {/* <button
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 dark:bg-gray-800/30 dark:hover:bg-gray-800/50 p-2 rounded-full text-gray-900 dark:text-white"
            onClick={nextSlide}
          >
            <ChevronRight size={24} />
          </button> */}

          {/* Carousel Text Overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white bg-black/40">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-center px-4 mb-8">
              {typedText}
            </h1>

            <div className="absolute bottom-0 left-0 right-0 bg-black/60 py-4">
              <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 px-4 text-center">
                <div>
                  <p className="text-gray-400 text-sm">PROPERTY TYPE</p>
                  <p className="font-medium">FARMLAND PLOTS</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">BUILD OPTIONS</p>
                  <p className="font-medium">
                    FARMHOUSE, COTTAGE, VILLA & LAWN
                  </p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">PRICE</p>
                  <p className="font-medium">Contact us to get quote now</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">LOCATION</p>
                  <p className="font-medium">
                    College Road, Near Hebsur Bus Stand, HEBSUR
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-16 lg:py-24 bg-gray-50 dark:bg-gray-800">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row gap-12 items-center">
              <div className="md:w-1/2">
                <div className="mb-6 flex justify-center md:justify-start">
                  <img
                    src="/svgs/logo2.jpg"
                    alt="Century Greens Logo"
                    className="h-16 md:h-20"
                  />
                </div>
                <div className="prose dark:prose-invert max-w-none">
                  <p className="text-lg">
                    Nestled amid 9 acres of abundant greenery, Sri Farmlands
                    blends seamlessly into the natural topography. Picture a
                    scenic place celebrated for its stunning landscapes, green
                    fields and pleasant climate. Its nestled along state highway
                    all the way connected from National highway. This is the
                    place you've always dreamt for. The best of nature, brought
                    right to your door step.
                  </p>
                  <p className="text-lg mt-4">
                    The project offers various amenities; whether you want to
                    have a picnic with your dear ones in between the plush
                    greens or a barbeque evening by your own farmhouse - this is
                    the place you have it all
                  </p>
                  <p className="text-lg mt-4">
                    An unmissable opportunity to own your piece of land and be
                    the artist of your own dream home. With myriad customisation
                    options at your disposal, you can utilise your space the way
                    you want it and also you can rent the property with help of
                    our management team for regular rental income.
                  </p>
                </div>
              </div>
              <div className="md:w-1/2">
                <img
                  src={"/svgs/plot_details.jpg"}
                  alt="Sriestate plot details"
                  className="w-full rounded-xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Project Highlights */}
        <section className="py-16 lg:py-24">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
              PROJECT HIGHLIGHTS
            </h2>

            <div className="flex flex-col md:flex-row gap-12 items-center">
              <div className="md:w-1/2">
                <img
                  src={"/svgs/house_details.jpg"}
                  alt="sriestate house design"
                  className="w-full rounded-xl shadow-lg"
                />
              </div>
              <div className="md:w-1/2">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>5 Gunta's Farm Plots</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>
                      East and West-facing farm plots for ideal vastu alignment.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>
                      Exclusive Farmhouse Amenities for the owners of the
                      farmland.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>
                      Well-planned farmland plots with fenced compound and gated
                      security for the community.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Amenities */}
        <section className="py-16 lg:py-24 bg-gray-50 dark:bg-gray-800">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
              World of Amenities
            </h2>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-6">
              {amenities.map((amenity, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center text-center"
                >
                  <div className="w-16 h-16 lg:w-20 lg:h-20 flex items-center justify-center text-3xl lg:text-4xl bg-white dark:bg-gray-700 rounded-full shadow-md mb-3">
                    {amenity.icon}
                  </div>
                  <p className="font-medium">{amenity.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-gray-100 dark:bg-gray-900 text-center">
          <div className="container mx-auto px-6">
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white">
              Explore Nearby Services
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mt-4">
              Discover hospitals, schools, restaurants, and more near your
              location.
            </p>
            <div className="mt-8">
              <Link
                to="/nearby"
                className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 text-lg font-medium rounded-lg shadow-lg hover:bg-blue-700 transition-all"
              >
                <MapPin size={20} />
                View Nearby Services
                <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        </section>

        {/* YouTube Video Showcase Section */}
        <section className="py-16 lg:py-24 bg-white dark:bg-gray-800">
          <div className="container mx-auto px-4">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Take a Virtual Tour
              </h2>
              <p className="text-lg max-w-3xl mx-auto text-gray-600 dark:text-gray-300">
                Explore our beautiful farmland plots through this detailed video
                tour. See the landscape, amenities, and envision your future in
                this serene natural paradise.
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="md:w-2/3 w-full">
                <div className="relative pb-[56.25%] h-0 overflow-hidden rounded-xl shadow-xl">
                  <iframe
                    src="https://www.youtube.com/embed/9Vi7UX8MTg0"
                    title="Sri estate tour"
                    className="absolute top-0 left-0 w-full h-full border-0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              <div className="md:w-1/3 w-full">
                <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3 flex items-center">
                    <YoutubeIcon className="text-red-600 mr-2" size={24} />
                    Video Highlights
                  </h3>

                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <PlayCircle
                        className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                        size={18}
                      />
                      <span>Aerial views of the entire property</span>
                    </li>
                    <li className="flex items-start">
                      <PlayCircle
                        className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                        size={18}
                      />
                      <span>Tour of available plot configurations</span>
                    </li>
                    <li className="flex items-start">
                      <PlayCircle
                        className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                        size={18}
                      />
                      <span>Showcase of premium amenities</span>
                    </li>
                    <li className="flex items-start">
                      <PlayCircle
                        className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                        size={18}
                      />
                      <span>
                        Upcoming Sri Lawn and Farmhouse property 3D visuals
                      </span>
                    </li>
                    <li className="flex items-start">
                      <PlayCircle
                        className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                        size={18}
                      />
                      <span>Nearby attractions and connectivity</span>
                    </li>
                  </ul>

                  <div className="mt-6">
                    <Link
                      to="/gallery"
                      className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all"
                    >
                      View More Videos
                      <ArrowRight size={16} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Site Plan */}
        {/* <section className="py-16 lg:py-24">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
              Site Plan
            </h2>

            <div className="max-w-4xl mx-auto">
              <img
                src={"/svgs/layout.jpg"}
                alt="plot in hebsur layout"
                className="w-full rounded-xl shadow-lg"
              />
            </div>
          </div>
        </section> */}

        {/* Location */}
        <section className="py-16 lg:py-24 bg-gray-50 dark:bg-gray-800">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
              Connectivity
            </h2>

            <div className="flex flex-col lg:flex-row gap-12">
              <div className="lg:w-1/2">
                <div className="w-full h-96 rounded-xl overflow-hidden shadow-lg">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15535.910230734667!2d75.2927778!3d15.4534444!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTXCsDI3JzEyLjQiTiA3NcKwMTcnMzQuMCJF!5e0!3m2!1sen!2sin!4v1648530116048!5m2!1sen!2sin"
                    className="w-full h-full border-0"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Location Map"
                  ></iframe>
                </div>
              </div>
              <div className="lg:w-1/2">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>200 mtrs from Govt. College</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>300 mtrs from SBI Bank</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>
                      700 mtrs from College Road near Hebsur Bus stand
                    </span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>
                      Eco-friendly lifestyle nestled in lush greenery.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>
                      Nearby restaurants, wine store, daily needs shop etc.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight
                      className="text-blue-600 mr-2 flex-shrink-0 mt-1"
                      size={20}
                    />
                    <span>
                      One of Hubli's most trusted developers with 8 years
                      experience and 5 completed projects.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Enquiry Form */}
        <section className="py-16 lg:py-24">
          <div className="container mx-auto px-4">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
              <div className="flex flex-col md:flex-row">
                <div className="md:w-1/2 p-8 lg:p-12">
                  <h2 className="text-2xl md:text-3xl font-bold mb-8">
                    Enquire Now
                  </h2>
                  <form className="space-y-4">
                    <div>
                      <input
                        type="text"
                        name="name"
                        placeholder="Name*"
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    <div>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number*"
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
                <div className="md:w-1/2 bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
                  <img
                    src={"/svgs/enquiry.jpg"}
                    alt="enquire form"
                    className="max-w-full max-h-full p-8"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* WhatsApp Floating Button */}
        <div className="fixed bottom-14 left-6 z-50">
          <a
            href="https://wa.me/1234567890"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-colors"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp Icon"
              className="w-8 h-8"
            />
          </a>
        </div>
      </main>
    </div>
  );
};

export default App;
